import FormControl from '@mui/material/FormControl';
import Grid from '@mui/material/Grid';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import TextField from '@mui/material/TextField';

export const Slot = ({ slot, onChange }) => {
    const handleOnChange = (e) => {
        const { value } = e.target;

        onChange({ shift: slot.shift, role: slot.role, name: slot.name, count: parseInt(value, 10) || 0, required: slot.required });
    };

    return (

        <Grid container spacing={ 2 } alignItems="center" sx={ { width: '100%' } }>
            <Grid size={ 4 }>
                <TextField label='Role Name' value={ slot.name } variant="outlined" fullWidth disabled />
            </Grid>

            <Grid size={ 4 }>
                <TextField label='Role Required' value={ slot.required || "No" } variant="outlined" fullWidth disabled />
            </Grid>

            <Grid size={ 4 }>
                <FormControl fullWidth>
                    <InputLabel id={ `${ slot.name }-count-label` }>Count</InputLabel>

                    <Select
                        labelId={ `${ slot.name }-count-label` }
                        label="Count"
                        id={ `${ slot.name }-count` }
                        name="count"
                        value={ slot.count }
                        onChange={ handleOnChange }
                        MenuProps={ { disableScrollLock: true } }
                    >
                        <MenuItem value={ 0 }>0</MenuItem>
                        <MenuItem value={ 1 }>1</MenuItem>
                        <MenuItem value={ 2 }>2</MenuItem>
                        <MenuItem value={ 3 }>3</MenuItem>
                        <MenuItem value={ 4 }>4</MenuItem>
                        <MenuItem value={ 5 }>5</MenuItem>
                        <MenuItem value={ 6 }>6</MenuItem>
                        <MenuItem value={ 7 }>7</MenuItem>
                        <MenuItem value={ 8 }>8</MenuItem>
                        <MenuItem value={ 9 }>9</MenuItem>
                        <MenuItem value={ 10 }>10</MenuItem>
                        <MenuItem value={ 11 }>11</MenuItem>
                        <MenuItem value={ 12 }>12</MenuItem>
                        <MenuItem value={ 13 }>13</MenuItem>
                        <MenuItem value={ 14 }>14</MenuItem>
                        <MenuItem value={ 15 }>15</MenuItem>
                        <MenuItem value={ 16 }>16</MenuItem>
                        <MenuItem value={ 17 }>17</MenuItem>
                        <MenuItem value={ 18 }>18</MenuItem>
                        <MenuItem value={ 19 }>19</MenuItem>
                        <MenuItem value={ 20 }>20</MenuItem>
                    </Select>
                </FormControl>
            </Grid>
        </Grid>
    );
};